import { Catalog } from './azing-interface/catalog.model';
/**
 * response from /app/azingManager/api/me/info
 */
export class Info {
  username: string;
  guid: string;
  url: string;
  edition: string;
  catalogs: Catalog[];

  constructor(data?: Info) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      // fix different property names (casing)
      this.username = data.Username !== undefined ? data.Username : (null as any);
      this.guid = data.Guid !== undefined ? data.Guid : (null as any);
      this.url = data.Url !== undefined ? data.Url : (null as any);
      this.edition = data.Edition !== undefined ? data.Edition : (null as any);
      this.catalogs = data.Catalogs !== undefined ? data.Catalogs : [];
    }
  }

  static fromJS(data: any): Info {
    data = typeof data === 'object' ? data : {};
    const result = new Info();
    result.init(data);
    return result;
  }
}
